<template>
  <div class="edit-preorder-view">
    <Navbar v-if="!isDesktop" />
    <NavbarDesktop
      :isOrderEditMenu="true"
      @onConfirmAction="finishEditing"
      @onDiscardAction="showAddDishUI"
      v-else-if="!adding_dish"
    />

    <div class="edit-preorder-content">
      <PreorderCard
        class="edit-preorder-card"
        @changeQuantity="onQuantityChanged"
        :preorder="preorder"
        v-if="preorder && !preorder.is_delivery && !adding_dish"
      />

      <DeliveryCard
        class="edit-preorder-card"
        @changeQuantity="onQuantityChanged"
        :preorder="preorder"
        v-if="preorder && preorder.is_delivery && !adding_dish"
      />
    </div>

    <div class="edit-preorder-navbar" v-if="!isDesktop && !adding_dish">
      <QueueButton variant="accept" class="add-dish" @click="showAddDishUI"
        >+ {{ $t("actions.add_dish") }}</QueueButton
      >
      <QueueButton class="confirm p-0" variant="accept" @click="finishEditing">
        <img src="../assets/ok.svg" />
      </QueueButton>
    </div>

    <AddDish
      editing_order
      @addMany="handleAddDish"
      @close="adding_dish = false"
      v-if="adding_dish"
    />
  </div>
</template>

<script>
import Navbar from "@/components/Navbar.vue";

import PreorderCard from "@/components/preorder/PreorderCard.vue";
import DeliveryCard from "@/components/delivery/DeliveryCard.vue";
import QueueButton from "@/components/QueueButton.vue";

import AddDish from "@/components/modals/AddDish.vue";

import NavbarDesktop from "@/components/NavbarDesktop.vue";

import QueueAPI from "@/api/queue";

export default {
  components: {
    Navbar,
    PreorderCard,
    QueueButton,
    DeliveryCard,
    AddDish,
    NavbarDesktop,
  },
  data() {
    return {
      preorder: null,
      adding_dish: false,
    };
  },
  methods: {
    onQuantityChanged(index, delta) {
      const item = this.preorder.list[index];

      if (delta > 0 && item.quantity < 30) {
        this.preorder.list[index].quantity += delta;
      }

      if (delta < 0) {
        if (item.quantity + delta <= 0) {
          if (this.preorder.list.length > 1)
            this.preorder.list.splice(index, 1);
        } else {
          this.preorder.list[index].quantity += delta;
        }
      }
    },
    finishEditing() {
      QueueAPI.editPreorder(this.preorder._id, this.preorder.list)
        .then((data) => {
          this.$router.push(
            `/orders?m=${this.preorder.is_delivery ? "delivery" : "preorder"}`
          );
        })
        .catch((error) => {
          this.$store.commit("setError", error);
        });
    },
    showAddDishUI() {
      this.adding_dish = true;
    },
    handleAddDish(items) {
      this.preorder.list = this.preorder.list.concat(items);
    },
    splitWeightedItems() {
      let list = [];

      for (let i = 0; i < this.preorder.list.length; i++) {
        const item = this.preorder.list[i];

        if (item.weight_flag == 2) {
          for (let q = 0; q < item.quantity; q++) {
            let new_item = Object.assign({}, item);
            new_item.quantity = 1;
            new_item.total_weight = new_item.total_weight / item.quantity;

            list.push(new_item);
          }
        } else {
          list.push(item);
        }
      }

      this.preorder.list = list;
    },
  },
  mounted() {
    if (!this.$store.state.initialized) {
      // this.$store.dispatch("init");
      this.$router.push("/orders");
      return;
    }

    const id = this.$route.params.preorder_id;

    this.preorder = this.$store.getters["preorder/findById"](id);
    this.preorder.status = "editing";
    this.splitWeightedItems();
  },
  computed: {
    isDesktop() {
      return window.innerWidth > 768;
    },
  },
};
</script>

<style>
.edit-preorder-card {
  padding: 8vh 0 15vh;
}

.edit-preorder-view {
}

.edit-preorder-navbar {
  position: fixed;
  background: #1d1d1b;
  padding: 1.3vh 3.2vh 2.6vh;
  display: flex;
  justify-content: space-between;
  left: 0;
  bottom: 0;
  z-index: 2;
  width: 100%;
}

.add-dish {
  background: transparent !important;
  border: 1px solid #129b81 !important;
  padding: 1.5vh;
  width: 100%;
  margin-right: 2vh;
}

.confirm {
  /* background: #416293; */
  background: #1d1d1b !important;
  color: #ededed !important;
}

.confirm img {
  width: 6vh;
  height: 6vh;
}

@media screen and (min-width: 768px) {
  .edit-preorder-card {
    padding-top: 20vh;
  }

  .edit-preorder-content {
    display: flex;
    justify-content: center;
  }
}
</style>